import { IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class ContactForm {
  @IsString()
  @IsNotEmpty()
  @MaxLength(200)
  subject: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(5000)
  body: string;
}
